module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "list_nav_wrap toggle-nav"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "sc-color"
  }, [_vm._l((_vm.list), function(item) {
    return [(item.value !== 4) ? _c('a', {
      style: ({
        'background-color': item.color
      }),
      attrs: {
        "title": item.name
      },
      on: {
        "click": function($event) {
          _vm.doSelect(item.value)
        }
      }
    }, [_c('i', {
      staticClass: "color-active  #if($!formBean.color!=11)#end",
      class: {
        hidden: (~~_vm.active !== item.value)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "color-hover hidden"
    })]) : _c('a', {
      staticStyle: {
        "height": "13px",
        "border-top": "1px solid #e5e5e7",
        "border-bottom": "1px solid #e5e5e7"
      },
      style: ({
        'background-color': item.color
      }),
      attrs: {
        "title": item.name
      },
      on: {
        "click": function($event) {
          _vm.doSelect(item.value)
        }
      }
    }, [_c('i', {
      staticClass: "color-active  #if($!formBean.color!=11)#end",
      class: {
        hidden: (~~_vm.active !== item.value)
      }
    }), _vm._v(" "), _c('span', {
      staticClass: "color-hover hidden"
    })])]
  })], 2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "list_nav_title"
  }, [_c('label', [_vm._v("颜色")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-73f9394a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components-buy/ListContain/NavContainer/ListNav/NavColor.vue
// module id = 870
// module chunks = 5